module.exports = __webpack_public_path__ + "images/fattest-stacks-655a1a2706c01687be467087c933b765.png";